import { ModelSagres } from "@/types/model-sagres";
import { defaultPorcentagem2DigitosFormatter } from "@/types/table-field";

export interface AvaliacaoJson {
  id: number;
  dhAvaliacao: string;
  dhInicio?: string;
  dhFim?: string;
  situacao: number;
  metricaDs: string;
  metricaAno: number;
  dsSituacao: string;
  urlBase: string;
  detalhe: string;
  ug?: {
    codUgSagres: string;
    nmSigla: string;
  }
  pontuacaos: any[];
}

export class Avaliacao extends ModelSagres {
  id: number;
  dhAvaliacao: Date;
  dhFim?: Date;
  dhInicio?: Date;
  dsResultado: string;
  resultado: number;
  metricaDs: string;
  metricaAno: number;
  classSituacao: string;
  dsSituacao: string;
  situacao: number;
  urlBase: string;
  detalhe: string;
  ug?: {
    codUgSagres: string;
    nmSigla: string;
  }
  metricaAnual: string


  /**
   * @param obj
   */
  constructor(obj?: AvaliacaoJson) {
    super();
    this.classSituacao = ''
    if (obj) {
      this.id = obj.id;
      this.dhAvaliacao = new Date(obj.dhAvaliacao);
      this.dhFim = obj.dhFim ? new Date(obj.dhFim) : undefined;
      this.dhInicio = obj.dhInicio ? new Date(obj.dhInicio): undefined;
      this.dsSituacao = obj.dsSituacao ?? undefined;
      this.situacao = obj.situacao;
      this.classSituacao = this.dsSituacao === 'Finalizado' ? 'success' : this.dsSituacao.includes('Fila') ? 'warning' : 'danger'
      this.urlBase = obj.urlBase;
      this.metricaAnual = `${obj.metricaDs} / ${obj.metricaAno}`;
      const pontuacao = obj.pontuacaos?.find((p) => p.tipoAnaliseId === 1)?.nota;
      if (pontuacao != null) {
        this.resultado = pontuacao;
        this.dsResultado = defaultPorcentagem2DigitosFormatter(pontuacao)
      }
      if(obj.detalhe === null) {
        this.detalhe = '-'
      } else {
        if(obj.detalhe.includes('Erro ao acessar portal') || obj.detalhe.includes('Não há hash no portal') || obj.detalhe.includes('Hash inválido ou não informado')) {
          this.detalhe = obj.detalhe;
        } else {
          this.detalhe = 'Erro interno';
        }
      }
      if (obj.ug) {
        this.ug = {
          codUgSagres: obj.ug.codUgSagres,
          nmSigla: obj.ug.nmSigla,
        }
      }
    }
  }
}
